import { criarParticipante } from '@/uteis/action/tramite/participante'

export const criarInstanciador = (dadosSessao) => {
  var instanciador = criarParticipante(dadosSessao.nomeUsuario, dadosSessao.login, 'LOGIN')
  var departamento = criarParticipante(dadosSessao.descricaoDepartamento, dadosSessao.idDepartamento, 'ID', dadosSessao.siglaDepartamento)
  var orgao = criarParticipante(dadosSessao.descricaoOrgao, dadosSessao.idOrgao, 'ID', dadosSessao.siglaOrgao)

  instanciador.participantePai = departamento
  departamento.participantePai = orgao

  return instanciador
}
